export enum ViewType {
    Hour = 0,
    Day = 1,
    Week = 2,
    Month = 3,
    Timeline = 4,
}